import { Decimal } from 'decimal.js';
import z from 'zod';
import { zodMoney } from './decimal.types.js';
import { TRANSACTION_METHOD_OPTIONS } from './transaction-method.types.js';
export const decimalPositiveSchema = z
    .instanceof(Decimal)
    .refine((value) => value.gt(0), 'Le montant doit être supérieur à 0');
const transactionMethodValues = TRANSACTION_METHOD_OPTIONS.map((option) => option.value);
const guidedTransactionMethodSchema = z.enum(transactionMethodValues);
export const guidedFormSchema = z.object({
    date: z.date(),
    amount: decimalPositiveSchema,
    debitFinancialAccountId: z.number().min(1, 'Le compte débité est requis'),
    creditFinancialAccountId: z.number().min(1, 'Le compte crédité est requis'),
    paymentMethod: z
        .union([z.literal(''), guidedTransactionMethodSchema])
        .refine((value) => value !== '', 'La méthode de transaction est requise'),
    accountingCategoryIds: z.array(z.number().int()).min(1, 'Au moins une catégorie est requise'),
});
export const transferFormSchema = z.object({
    date: z.date(),
    amount: decimalPositiveSchema,
    debitFinancialAccountId: z.number().min(1, 'Le compte débité est requis'),
    creditFinancialAccountId: z.number().min(1, 'Le compte crédité est requis'),
    // A PCG class-58 transit account is required: an internal transfer always posts two entries
    // (source→58, then 58→destination) so each bank is reconciled in its own journal. `undefined`
    // until prefilled from the chart of accounts (submit is blocked until a 58 account is chosen).
    transitFinancialAccountId: z
        .number()
        .int()
        .positive('Un compte de transit (classe 58) est requis')
        .optional(),
});
// API payload for POST /transactions/internal-transfer. An internal transfer always goes through a
// PCG class-58 transit account: the backend posts two balanced entries (Débit source / Crédit 58,
// then Débit 58 / Crédit dest), each in its account's associated journal, so each bank is
// reconciled in its own journal.
export const internalTransferDataSchema = z.object({
    date: z.coerce.date(),
    amount: zodMoney(),
    debitFinancialAccountId: z.number().int().positive('Le compte à débiter est requis'),
    creditFinancialAccountId: z.number().int().positive('Le compte à créditer est requis'),
    transitFinancialAccountId: z
        .number()
        .int()
        .positive('Un compte de transit (classe 58) est requis'),
    label: z.string().min(1, "L'intitulé est requis"),
});
